import React from 'react';
import gql from 'graphql-tag';

import { Form } from 'tabler-react';
import { Query } from 'react-apollo';
import { sourceLabel } from '../utils/source';
import './LocationSelect.css';

const LOCATIONS = gql`
query getLocations {
  fullLocations {
    name
    displayName
    source
  }
}
`;

const stateMapping = [
  {
    State: 'Alabama',
    Abbrev: 'Ala.',
    Code: 'AL',
  },
  {
    State: 'Alaska',
    Abbrev: 'Alaska',
    Code: 'AK',
  },
  {
    State: 'Arizona',
    Abbrev: 'Ariz.',
    Code: 'AZ',
  },
  {
    State: 'Arkansas',
    Abbrev: 'Ark.',
    Code: 'AR',
  },
  {
    State: 'California',
    Abbrev: 'Calif.',
    Code: 'CA',
  },
  {
    State: 'Colorado',
    Abbrev: 'Colo.',
    Code: 'CO',
  },
  {
    State: 'Connecticut',
    Abbrev: 'Conn.',
    Code: 'CT',
  },
  {
    State: 'Delaware',
    Abbrev: 'Del.',
    Code: 'DE',
  },
  {
    State: 'District of Columbia',
    Abbrev: 'D.C.',
    Code: 'DC',
  },
  {
    State: 'Florida',
    Abbrev: 'Fla.',
    Code: 'FL',
  },
  {
    State: 'Georgia',
    Abbrev: 'Ga.',
    Code: 'GA',
  },
  {
    State: 'Hawaii',
    Abbrev: 'Hawaii',
    Code: 'HI',
  },
  {
    State: 'Idaho',
    Abbrev: 'Idaho',
    Code: 'ID',
  },
  {
    State: 'Illinois',
    Abbrev: 'Ill.',
    Code: 'IL',
  },
  {
    State: 'Indiana',
    Abbrev: 'Ind.',
    Code: 'IN',
  },
  {
    State: 'Iowa',
    Abbrev: 'Iowa',
    Code: 'IA',
  },
  {
    State: 'Kansas',
    Abbrev: 'Kans.',
    Code: 'KS',
  },
  {
    State: 'Kentucky',
    Abbrev: 'Ky.',
    Code: 'KY',
  },
  {
    State: 'Louisiana',
    Abbrev: 'La.',
    Code: 'LA',
  },
  {
    State: 'Maine',
    Abbrev: 'Maine',
    Code: 'ME',
  },
  {
    State: 'Maryland',
    Abbrev: 'Md.',
    Code: 'MD',
  },
  {
    State: 'Massachusetts',
    Abbrev: 'Mass.',
    Code: 'MA',
  },
  {
    State: 'Michigan',
    Abbrev: 'Mich.',
    Code: 'MI',
  },
  {
    State: 'Minnesota',
    Abbrev: 'Minn.',
    Code: 'MN',
  },
  {
    State: 'Mississippi',
    Abbrev: 'Miss.',
    Code: 'MS',
  },
  {
    State: 'Missouri',
    Abbrev: 'Mo.',
    Code: 'MO',
  },
  {
    State: 'Montana',
    Abbrev: 'Mont.',
    Code: 'MT',
  },
  {
    State: 'Nebraska',
    Abbrev: 'Nebr.',
    Code: 'NE',
  },
  {
    State: 'Nevada',
    Abbrev: 'Nev.',
    Code: 'NV',
  },
  {
    State: 'New Hampshire',
    Abbrev: 'N.H.',
    Code: 'NH',
  },
  {
    State: 'New Jersey',
    Abbrev: 'N.J.',
    Code: 'NJ',
  },
  {
    State: 'New Mexico',
    Abbrev: 'N.M.',
    Code: 'NM',
  },
  {
    State: 'New York',
    Abbrev: 'N.Y.',
    Code: 'NY',
  },
  {
    State: 'North Carolina',
    Abbrev: 'N.C.',
    Code: 'NC',
  },
  {
    State: 'North Dakota',
    Abbrev: 'N.D.',
    Code: 'ND',
  },
  {
    State: 'Ohio',
    Abbrev: 'Ohio',
    Code: 'OH',
  },
  {
    State: 'Oklahoma',
    Abbrev: 'Okla.',
    Code: 'OK',
  },
  {
    State: 'Oregon',
    Abbrev: 'Ore.',
    Code: 'OR',
  },
  {
    State: 'Pennsylvania',
    Abbrev: 'Pa.',
    Code: 'PA',
  },
  {
    State: 'Rhode Island',
    Abbrev: 'R.I.',
    Code: 'RI',
  },
  {
    State: 'South Carolina',
    Abbrev: 'S.C.',
    Code: 'SC',
  },
  {
    State: 'South Dakota',
    Abbrev: 'S.D.',
    Code: 'SD',
  },
  {
    State: 'Tennessee',
    Abbrev: 'Tenn.',
    Code: 'TN',
  },
  {
    State: 'Texas',
    Abbrev: 'Tex.',
    Code: 'TX',
  },
  {
    State: 'Utah',
    Abbrev: 'Utah',
    Code: 'UT',
  },
  {
    State: 'Vermont',
    Abbrev: 'Vt.',
    Code: 'VT',
  },
  {
    State: 'Virginia',
    Abbrev: 'Va.',
    Code: 'VA',
  },
  {
    State: 'Washington',
    Abbrev: 'Wash.',
    Code: 'WA',
  },
  {
    State: 'West Virginia',
    Abbrev: 'W.Va.',
    Code: 'WV',
  },
  {
    State: 'Wisconsin',
    Abbrev: 'Wis.',
    Code: 'WI',
  },
  {
    State: 'Wyoming',
    Abbrev: 'Wyo.',
    Code: 'WY',
  },
];


const LocationGroup = ({
  locations,
  groupName,
  ...props
}) => {
  const [isHidden, setHidden] = React.useState(false);
  return (
    <React.Fragment>
      <Form.Label className="StateGroup" onClick={() => setHidden(!isHidden)}>
        {groupName}
      </Form.Label>
      {!isHidden && locations.map(location => <CheckboxOption key={location.name} location={location} {...props} />)}
      <hr />
    </React.Fragment>
  );
};

const CheckboxOption = ({
  onChange, currentLocations, location,
}) => (
  <Form.Checkbox
    checked={(currentLocations || []).includes(location.name)}
    label={location.displayName}
    name="sort"
    value={location.name}
    onChange={onChange}
  />
);

// A source checkbox stands for the full set of that source's locations: checked
// means every one of them is selected; toggling selects/deselects them all at
// once. Filtering still travels through the existing `locations` search arg.
const SourceOption = ({
  source, locations, currentLocations, handleSetLocations,
}) => {
  const locationNames = locations.map(({ name }) => name);
  const checked = locationNames.length > 0 && locationNames.every(name => (currentLocations || []).includes(name));
  const toggle = () => {
    const selected = currentLocations || [];
    if (checked) {
      handleSetLocations(selected.filter(name => !locationNames.includes(name)));
    } else {
      handleSetLocations([...selected, ...locationNames.filter(name => !selected.includes(name))]);
    }
  };
  return (
    <Form.Checkbox
      checked={checked}
      label={sourceLabel(source)}
      name="source"
      value={source}
      onChange={toggle}
    />
  );
};

const SourceOptions = ({ fullLocations, currentLocations, handleSetLocations }) => {
  const locationsBySource = fullLocations.reduce((agg, location) => {
    const source = location.source || 'bidfta';
    if (!agg[source]) {
      agg[source] = [];
    }
    agg[source].push(location);
    return agg;
  }, {});
  const sources = Object.keys(locationsBySource);
  if (!handleSetLocations || sources.length < 2) return null;
  return (
    <React.Fragment>
      <Form.Label className="StateGroup">Source</Form.Label>
      {sources.map(source => (
        <SourceOption
          key={source}
          source={source}
          locations={locationsBySource[source]}
          currentLocations={currentLocations}
          handleSetLocations={handleSetLocations}
        />
      ))}
      <hr />
    </React.Fragment>
  );
};

const LocationOptions = ({ handleSelectLocation, handleSetLocations, locations: currentLocations }) => (
  <Form.Group label="Locations">
    <Query query={LOCATIONS}>
      {({ data: { fullLocations = [] } = { fullLocations: [] } }) => {
        const groupedLocations = fullLocations.reduce((agg, location) => {
          let state = location.displayName.split(' ').slice(-1)[0];
          if (stateMapping.find(({ Code }) => Code === state)) {
            state = stateMapping.find(({ Code }) => Code === state).State;
          }
          if (!agg[state]) {
            agg[state] = [];
          }
          agg[state].push(location);
          return agg;
        }, {});
        return (
          <React.Fragment>
            <SourceOptions
              fullLocations={fullLocations}
              currentLocations={currentLocations}
              handleSetLocations={handleSetLocations}
            />
            {Object.keys(groupedLocations).map(state => <LocationGroup locations={groupedLocations[state]} groupName={state} onChange={handleSelectLocation} currentLocations={currentLocations} />)}
          </React.Fragment>
        );
      }}
    </Query>
  </Form.Group>
);

export default LocationOptions;



// WEBPACK FOOTER //
// ./src/components/LocationSelect.js